import React from 'react';
import Hero from './components/exam-rules/Hero';
import Main from './components/exam-rules/Main';

const ExamRules = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default ExamRules;